import qs from 'qs';
import Pagination from 'core/models/pagination';
import CustoFixo from 'core/models/FIN/custoFixo';
import api from '../api';

const baseURL = `/FIN/CustoFixo`;

export const getCustoFixoList = async (filters) => {
  const response = await api.get(`${baseURL}/Search`, {
    params: filters,
  });
  const { status, message, value } = response.data ?? {};

  return {
    status,
    message,
    data: value?.map((json) => new CustoFixo(json)) ?? [],
  };
};

export const AlteracaoDia = async (data) => {
  const response = await api.post(`${baseURL}/AlteracaoDia`, data);
  return response.data ?? {};
};

export const updateReferenceSalaryDriversAndEmployees = async () => {
  const response = await api.post(
    `${baseURL}/UpdateReferenceSalaryDriversAndEmployees`
  );
  return response.data ?? {};
};

export const UpdateReferenceDriversAndEmployees = async (data) => {
  const response = await api.post(
    `${baseURL}/UpdateReferenceDriversAndEmployees`,
    data
  );
  return response.data ?? {};
};

export const getCustoFixoPagined = async (filters) => {
  const response = await api.get(`${baseURL}/SearchPagined`, {
    params: filters,
  });
  const { status, message, value, pagination } = response.data ?? {};

  return {
    status,
    message,
    data: value?.map((json) => new CustoFixo(json)) ?? [],
    pagination: new Pagination(pagination),
  };
};

export const getCustoFixo = async (id) => {
  const response = await api.get(`${baseURL}/`, {
    params: { id },
  });
  const { value } = response.data ?? {};
  return value ? new CustoFixo(value) : {};
};

export const saveCustoFixo = async (data) => {
  const response = await api.post(`${baseURL}/`, data);
  return response.data ?? {};
};

export const deleteCustoFixo = async (id) => {
  const response = await api.delete(`${baseURL}/`, { params: { id } });
  return response.data ?? {};
};

export const printCustoFixo = async (filters) => {
  const response = await api.get(`${baseURL}/Print`, {
    params: filters,
  });
  return response.data ?? {};
};

export const excelCustoFixo = async (filters) => {
  const response = await api.get(`${baseURL}/Excel`, {
    params: filters,
  });
  return response.data ?? {};
};

export const deleteAllCustoFixo = async (ids) => {
  const response = await api.delete(`${baseURL}/DeleteAll`, {
    params: { ids },
    paramsSerializer: (params) => qs.stringify(params),
  });
  return response.data ?? {};
};
